import AllRecipes from "./AllRecipes.component";

export default AllRecipes;
